export default __webpack_public_path__ + "static/media/infographic_MSB.ab5b34a1.svg";